/**
 * Format text by translating specific phrases and status indicators.
 *
 * @param {string} string The string to format and translate.
 * @return {string} The formatted and translated string.
 */
export const getMessage = (string: string, t: Function) => {
    string = string.replace('AI_CALL_COMMENT', t('Comments.AI_CALL_COMMENT'));

    string = string.replace(
        'AI_WHATSAPP_MESSAGE_CALL_CONFIRMATION_COMMENT',
        t('Comments.AI_WHATSAPP_MESSAGE_CALL_CONFIRMATION_COMMENT')
    );

    string = string.replace(
        'AI_CALL_SCHEDULE_COMMENT',
        t('Comments.AI_CALL_SCHEDULE_COMMENT')
    );

    string = string.replace(
        'PRESENTATION_CARD_COMMENT',
        t('Comments.PRESENTATION_CARD_COMMENT')
    );

    string = string.replace(
        '[FLEET_COMMENT]',
        `: ${t('Comments.[FLEET_COMMENT]')}`
    );

    string = string.replace(
        'AI_COMMENT_WHATSAPP',
        t('Comments.AI_COMMENT_WHATSAPP')
    );

    string = string.replace(
        'Se ha realizado una llamada con',
        t('Messages.PhoneCall')
    );

    string = string.replace('completed', t('Status.completed'));

    string = string.replace('busy', t('Status.busy'));

    string = string.replace('error', t('Status.error'));

    string = string.replace('no-answer', t('Status.no-answer'));

    string = string.replace('failed', t('Status.failed'));

    return string;
};
